import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import getWeeks from './getWeeks';

const getCurrentWeek = (earlier: Date | number, later: Date | number) => {
  const days = differenceInCalendarDays(earlier, later);
  return getWeeks(days);
};
export default getCurrentWeek;
